import { PreferencesData, ProgramEnrollment } from "./types";

export const preferencesKeys = {
  list: ["preferences"],
};

/**
 * @param id Program ID
 * @param key Preference key
 * @param enabled If the preference is enabled
 * @param previousPreferences The previous cached preferences
 * @returns Updated preferences for react-query cache.
 */
export const getUpdatedProgramPreferences = (
  id: number,
  key: string,
  enabled: boolean,
  previousPreferences: PreferencesData
): PreferencesData => ({
  data: {
    ...previousPreferences.data,
    program_enrollments: {
      data: previousPreferences.data.program_enrollments.data.map(
        (program: ProgramEnrollment) => {
          if (program.program_id === id) {
            return {
              ...program,
              [key]: enabled,
            };
          }

          return program;
        }
      ),
    },
  },
});
